export default Object.freeze({
  AUTOPILOT: '3ac9d21a8c344a1080bd951d62d4ebef',
});
